import { useEffect, useState } from 'react';
import { Navigate } from 'react-router';
import { LoadingPage } from '@/pages/other/LoadingPage';

interface DisabledFeatureRedirectProps {
  to?: string;
}

/**
 * Component that handles redirects for disabled features.
 * Shows loading state briefly before redirect to prevent visual flash.
 */
export const DisabledFeatureRedirect: React.FC<DisabledFeatureRedirectProps> = ({ 
  to = '/' 
}) => {
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => {
      setShouldRedirect(true);
    });
  }, []);

  if (shouldRedirect) {
    return <Navigate to={to} replace />;
  }

  return <LoadingPage />;
};

export default DisabledFeatureRedirect;
